import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { computed, ref } from "vue";
import { sortByRank, returnActiveItems } from "../factory";
export const EventStaffFunctionDefinitionFragment = gql `
  fragment _ on EventStaffFunctionDefinition {
    id
    name
    rank
    status
    competitionLevelIds
    profQualificationIds
  }
`;
export function useEventStaffFunctionDefinitionsHelper() {
    const masterEventStaffFunctionDefinitonsLoading = ref(true);
    const masterEventStaffFunctionDefinitons = ref([]);
    const masterEventStaffFunctionDefinitonsActive = computed(() => returnActiveItems(masterEventStaffFunctionDefinitons.value));
    apolloClient
        .query({
        query: gql `
        query MasterEventStaffFunctionDefinitions {
          eventStaffFunctionDefinitions {
            ${EventStaffFunctionDefinitionFragment}
          }
        }
      `,
        fetchPolicy: "cache-first"
    })
        .then(({ data }) => {
        masterEventStaffFunctionDefinitonsLoading.value = false;
        masterEventStaffFunctionDefinitons.value = sortByRank(data.eventStaffFunctionDefinitions);
    });
    return {
        masterEventStaffFunctionDefinitonsLoading,
        masterEventStaffFunctionDefinitons,
        masterEventStaffFunctionDefinitonsActive
    };
}
